export default __webpack_public_path__ + "static/media/donnisira-into-teamswork.d977e0d6.svg";